export const DEFAULT_PROFILE_IMG = "https://res.cloudinary.com/dnu4ciook/image/upload/v1653229201/profile1_xjv2nc.png"
export const DEFAULT_BACKGROUND_COLOR = "black";
export const DEFAULT_TEXT_COLOR = "white";
export const DEFAULT_BUTTONS_TEXT_COLOR = "black";
export const DEFAULT_BUTTONS_COLOR = "white";
export const DEFAULT_BUTTONS_BODER_COLOR = "transparent";